<template>
  <div class="rounded pa-3 bg-grey-lighten-5 my-2 bordered">
    <div class="mb-2"><b>Taille : {{ size.nom }}</b> <v-chip color="primary-dark" variant="elevated" elevation="0" density="compact">{{ size.nb_reservations }} commandes</v-chip></div>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="size.quantite" type="number" label="Quantité max (0 si pas de limite)"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      size: {},
    };
  },
  mounted() {
    this.size = this.item;
  },
};
</script>

<style lang="scss" scoped></style>
